// Helpers for the rich-text question prompt (stored as HTML).

/** Strip tags to readable plain text — for list rows, tooltips, and "empty?" checks. */
export function htmlToPlainText(html: string): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  // Surface formulas as their LaTeX so previews aren't blank where math is the only content.
  doc.querySelectorAll('span[data-math]').forEach((el) => {
    el.textContent = el.getAttribute('data-math') || '';
  });
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}

/** True when the HTML carries no visible content (no text, images, or formulas). */
export function isRichTextEmpty(html: string): boolean {
  if (!html) return true;
  if (/<(img|span[^>]*data-math)/i.test(html)) return false;
  return htmlToPlainText(html).length === 0;
}
